import {useNavigate} from 'react-router-dom';
import {useIntl} from 'react-intl';
import {toAbsoluteUrl} from '../../../_metronic/helpers';
import {PageTitle} from '../../../_metronic/layout/core';

const logo = toAbsoluteUrl('/media/logos/LOGO_CELESTE_Sans_Baseline_Bleu.png');

interface ComingSoonProps {
  title?: string;
}

const ComingSoon = ({title}: ComingSoonProps): JSX.Element => {
  const navigate = useNavigate();
  const intl = useIntl();

  return (
    <>
      {title && <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: title})}</PageTitle>}
      <div className="d-flex flex-column align-items-center justify-content-center" style={{minHeight: '60vh', gap: '2rem'}}>
        <img src={logo} alt="Celeste" style={{width: '440px'}} />
        <div className="text-center">
          <p className="fs-3 fw-semibold text-gray-700">
            {intl.formatMessage({id: 'COMING_SOON.MESSAGE'})}
          </p>
          <button className="btn btn-primary mt-3" onClick={() => navigate('/')}>
            {intl.formatMessage({id: 'COMING_SOON.BACK_TO_DASHBOARD'})}
          </button>
        </div>
      </div>
    </>
  );
};

export default ComingSoon;
